import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-peb-chauffage',
  templateUrl: './service-peb-chauffage.component.html',
  styleUrls: ['./service-peb-chauffage.component.scss']
})
export class ServicePebChauffageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
